export default __webpack_public_path__ + "static/img-home-guiding-principles-383ae64d1d3800f2c8c9172ebd33a773.png";